import { buttonSlots } from "@stubhub/broadway-foundation";
import { css, cva, sva } from "@stubhub/broadway-foundation/css";

export const calendarContainer = css({
  backgroundColor: "bg.surface",
  paddingBlockEnd: "primitives.150",
  // Ensure nothing overflows the container
  overflowX: "hidden",
  overflowY: "hidden",
});

export const weekdaysHeader = css({
  display: "flex",
  paddingBlockEnd: "primitives.100",
  columnGap: "primitives.150",
  rowGap: "primitives.150",
  // Fixed width for exactly 7 items - reduced slightly to hide 8th item completely
  width: "[calc(7 * {spacing.primitives.500} + 6 * {spacing.primitives.150} + 1.5 * {spacing.primitives.200})]",
  maxWidth: "full",
  marginBlock: "primitives.0",
  marginInline: "auto",
});

export const datesContainerWrapper = css({
  overflowX: "hidden",
  overflowY: "hidden",
  // Fixed width reduced to ensure 8th item is completely hidden (reduced right padding)
  width: "[calc(7 * {spacing.primitives.500} + 6 * {spacing.primitives.150} + 1.5 * {spacing.primitives.200})]",
  maxWidth: "full", // Never exceed screen width
  position: "relative",
  // Center the container
  marginBlock: "primitives.0",
  marginInline: "auto",
});

export const weekdayItem = css({
  minWidth: "primitives.500",
  textAlign: "center",
});

export const datesContainer = css({
  display: "flex",
  overflowX: "auto",
  scrollSnapType: "[x mandatory]",
  columnGap: "primitives.150",
  rowGap: "primitives.150",
  scrollBehavior: "smooth",
  _scrollbar: {
    display: "none",
  },
  scrollbarWidth: "[none]",
});

export const dateButtonStyles = sva({
  slots: buttonSlots,
  className: "dateButton",
  base: {
    root: {
      position: "relative",
      // eslint-disable-next-line panda/no-important -- TODO: remove `!important`
      color: "text !important",
      minWidth: "primitives.500",
      width: "primitives.500",
      height: "primitives.500",
      scrollSnapAlign: "start",
      display: "flex",
      flexShrink: 0,
      backgroundColor: "[transparent]",
      _hover: {
        backgroundColor: "[transparent]",
      },
    },
  },
  variants: {
    activation: {
      active: {
        root: {
          // eslint-disable-next-line panda/no-important -- TODO: remove `!important`
          backgroundColor: "bg.surface.stronger !important",
        },
      },
      inactive: {},
    },
    interactivity: {
      enabled: {},
      disabled: {
        root: {
          // eslint-disable-next-line panda/no-important -- TODO: remove `!important`
          backgroundColor: "[transparent !important]",
          color: "text.disabled",
          cursor: "default",
          _hover: {
            // eslint-disable-next-line panda/no-important -- TODO: remove `!important`
            backgroundColor: "[transparent !important]",
          },
        },
      },
    },
  },
  defaultVariants: {
    activation: "inactive",
    interactivity: "enabled",
  },
});

export const eventIndicatorDot = css({
  position: "absolute",
  insetBlockEnd: "primitives.50",
  insetInlineStart: "[50%]",
  transform: "translateX(-50%)",
  width: "primitives.50",
  height: "primitives.50",
  borderStartStartRadius: "full",
  borderStartEndRadius: "full",
  borderEndStartRadius: "full",
  borderEndEndRadius: "full",
  pointerEvents: "none",
});

export const eventInfo = css({
  display: "flex",
  flexDirection: "column",
  alignItems: "stretch",
  columnGap: "primitives.50",
  rowGap: "primitives.50",
});

export const eventContent = css({
  display: "flex",
  alignItems: "center",
  columnGap: "primitives.100",
  rowGap: "primitives.100",
});

export const teamLogo = css({
  height: "[40px]",
  width: "[40px]",
});

export const eventTextInfo = css({
  display: "flex",
  flexDirection: "column",
  columnGap: "primitives.25",
  rowGap: "primitives.25",
  alignItems: "flex-start",
});

export const homeGameIndicator = css({
  position: "absolute",
  insetInlineStart: "primitives.0",
  insetBlock: "primitives.0",
  width: "[8px]",
  borderStartStartRadius: "container",
  borderEndStartRadius: "container",
});

export const teamName = css({
  lineHeight: "[1.2]",
});

export const eventDetails = css({
  color: "text.subtle",
});

export const textDisabled = css({
  color: "text.disabled",
});

export const teamNameRecipe = cva({
  base: {
    lineHeight: "[1.2]",
  },
  variants: {
    availability: {
      available: {},
      unavailable: { color: "text.disabled" },
    },
  },
  defaultVariants: { availability: "available" },
});

export const eventDetailsRecipe = cva({
  base: {
    color: "text.subtle",
  },
  variants: {
    availability: {
      available: {},
      unavailable: { color: "text.disabled" },
    },
  },
  defaultVariants: { availability: "available" },
});
